import { Component, OnChanges, OnInit, OnDestroy, SimpleChanges, Input, ViewChild, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { PlanificadorService } from '../models/control.service';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { GestionService } from 'src/app/services/gestion.services';
import { OpesalidaDialogComponent } from '../broker/opesalida-dialog/opesalida-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TemaService } from 'src/app/services/tema.services';
import { MatSort } from '@angular/material/sort';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { PosicionesBrokerComponent } from './posiciones-broker/posiciones-broker.component';
import { ListaOrdenesComponent } from './lista-ordenes/lista-ordenes.component';
import { agregaTiporModelo, flattenArray } from './cartera-utils';

@Component({
  selector: 'app-cartera',
  templateUrl: './cartera.component.html',
  styleUrl: './cartera.component.scss'
})
export class CarteraComponent implements OnInit, OnDestroy, OnChanges {
  panelOpenState = false;
  colPanelOpen = false;
  private subTemaService: Subscription;
  public isDark: boolean = false;
  private posSubcription: Subscription;
  public posdata: CdkTableVirtualScrollDataSource<operationinterface>;
  public modeloCalculadoEn = '';
  @ViewChild(MatSort) sort: MatSort;
  private divPosSubcription: Subscription;
  public divPosdata: CdkTableVirtualScrollDataSource<operationinterface>;
  private gestPosSubcription: Subscription;
  public gestPosdata: CdkTableVirtualScrollDataSource<operationinterface>;
  public GestOptimaWallet: any;
  private subGestOptima: Subscription;
  private fechaSubcription: Subscription;
  public indexcat: any;
  public indexCatDiv: any;
  public indexCatGest: any;
  contador: number = 100;
  datawhatif: any[] = [];
  @Input() selectedTab: number = 0;
  @Input() loading: boolean = false;
  @Input() modelo: boolean = false;
  @Input() isPlanificador: boolean = false;
  @Input() isGestion: boolean = false;
  @Input() isBroker: boolean = false;
  @Input() stkcfd: string = '';
  @Output() listaOrdenesBroker: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestion!: CdkVirtualScrollViewport;//
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportDiv!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportCarteraGest!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) operaciones!: CdkVirtualScrollViewport;
  @ViewChild(PosicionesBrokerComponent, { static: false }) posicionesBroker?: PosicionesBrokerComponent;
  @ViewChild(ListaOrdenesComponent, { static: false }) listaOrdenes?: ListaOrdenesComponent;
  tableColumns: TableColmuns[] = [
    { id: 'numoperaciones', name: 'N', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'tipomodelo', name: 'Tipo Entrada', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'isooper', name: 'ID', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'nombreCompania', name: 'Compañia', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'fechaOperacion', name: 'Registro', isShow: true, isDate: true, isNumber: false, isString: false },
    { id: 'hora', name: 'Hora', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'lastExecutionTimer', name: 'Ejecucion Broker', isShow: false, isDate: false, isNumber: false, isString: true },
    //  { id: 'horaFormato', name: 'Hora', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'precioentradareal', name: 'Entrada', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'cantidadacciones', name: 'N° Acciones', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorriesgo', name: 'Riesgo', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'fechaCotizacion', name: 'Fecha Actual', isShow: false, isDate: true, isNumber: false, isString: false },
    { id: 'horaCotizacion', name: 'Hora Cotización', isShow: true, isDate: false, isNumber: false, isString: true },
    { id: 'cotizacion', name: 'Cotizacion', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'stoploss', name: 'Stoploss', isShow: false, isDate: false, isNumber: true, isString: false },
    { id: 'stoplossactual', name: 'Stoploss Actual', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'profit', name: 'Profit', isShow: false, isDate: false, isNumber: false, isString: true },
    { id: 'valorlatente', name: 'Beneficio', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'valorlatentepor', name: 'Beneficio %', isShow: true, isDate: false, isNumber: true, isString: false },
    { id: 'margenbroker', name: 'Margen B', isShow: true, isDate: false, isNumber: true, isString: false },

  ]

  displayedColumns: string[] = ['numoperaciones', 'isooper', 'nombreCompania', 'fechaOperacion', 'hora'
    , 'precioentradareal', 'cantidadacciones',/** 'fechaCotizacion',*/ 'horaCotizacion', 'cotizacion',
    'valorlatente', 'valorlatentepor', 'margenbroker'];

  public filaSeleccionada: any;

  /** BROKER: fracción del alto para posiciones (el resto es la lista de órdenes), ajustable con el divisor. */
  public splitRatio = CarteraComponent.leerSplitRatio();
  private finResize: (() => void) | null = null;
  /** Alto total de posiciones + órdenes (sin el divisor de 6px). */
  private static readonly ALTO_SPLIT = '(100vh - 200px)';

  get altoPosiciones(): string { return `calc(${CarteraComponent.ALTO_SPLIT} * ${this.splitRatio})`; }
  get altoOrdenes(): string { return `calc(${CarteraComponent.ALTO_SPLIT} * ${1 - this.splitRatio})`; }

  public queryParams: string;
  public row: any;
  public opeVentas: any;
  theme: string | string[] | undefined;
  contadorFilas: number;

  constructor(private _controlService: PlanificadorService, private datePipe: DatePipe,
    private _diversificadorsv: DiversificadorService,
    private _gestorsv: GestionService,
    public dialog: MatDialog,
    public temaService: TemaService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService) {

    this.posdata = new CdkTableVirtualScrollDataSource<operationinterface>();
    this.divPosdata = new CdkTableVirtualScrollDataSource<operationinterface>();
    this.gestPosdata = new CdkTableVirtualScrollDataSource<operationinterface>();
  }


  ngOnInit(): void {
    if (!this.isBroker) {
      this.tableColumns.pop();
      this.displayedColumns.pop();
    }
    this.posSubcription = this._controlService.valPos$.subscribe({
      next: (data: any) => {
        //    let temporal = this.agregaTiporModelo(data);
        let temporal = this.agregaTiporModelo(this.flattenArray(data));
        this.posdata.data = temporal;
        // `hora` de las posiciones del modelo es cuándo se calculó, no cuándo ocurrió la operación.
        const calculado = Math.max(0, ...temporal.map((o: any) => Number(o.hora) || 0));
        this.modeloCalculadoEn = calculado > 0
          ? this.datePipe.transform(new Date(calculado * 1000), 'HH:mm dd-MM-yyyy') || ''
          : '';
      }
    });
    this.fechaSubcription = this._controlService.valFechaFiltro$.subscribe({
      next: (data: any) => {
        if (data != '') { this.scrollToFirstDate(data); }
      }
    });

    this.divPosSubcription = this._diversificadorsv.valDivValPos$.subscribe({
      next: (data: any) => {
        let temporal = this.agregaTiporModelo(this.flattenArray(data));
        this.divPosdata.data = temporal;
      }
    });
    //-------------- gestor---
    this.gestPosSubcription = this._gestorsv.valGestValPos$.subscribe({
      next: (data: any) => {
        this.opeVentas = (data);
        let temporal = this.agregaTiporModelo(this.flattenArray(data));
        //  console.log("TEMPORAL TEMPORAL",temporal );
        //  this.gestPosdata.data = this.flattenArray(data);
        this.gestPosdata.data = this.flattenArray(temporal);
      }
    });
    this.subGestOptima = this._gestorsv.valgestOptimaWallet$.subscribe({
      next: (data: any) => {
        this.GestOptimaWallet = data;
      }
    });
    // BROKER: posiciones y órdenes viven en app-posiciones-broker / app-lista-ordenes
    this.subTemaService = this.temaService.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
  }

  agregaTiporModelo(data: any[]): any[] {
    return agregaTiporModelo(data);
  }

  ngAfterViewInit(): void {
    this.actualizarViewport();
    this.cdr.detectChanges();
  }

  flattenArray(arrayOfArrays: any[]): any[] {
    return flattenArray(arrayOfArrays);
  }

  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  toggleColumnVisibility(id: any) {
    const column = this.tableColumns.find(col => col.id === id);
    if (column) {
      column.isShow = !column.isShow;
      this.displayedColumns = this.tableColumns.filter(col => col.isShow).map(col => col.id);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.selectedTab === 4) {
      this.actualizarViewport();
      console.log("XXXXX :", this.selectedTab);
      if (this.modelo) {
        if (this.indexcat !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexcat) * rowHeight;
          this.viewportGestion.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      } else if (this.isPlanificador) {
        if (this.indexCatDiv !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexCatDiv) * rowHeight;
          this.viewportDiv.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      }/* else if(this.isGestion){
        if (this.indexGest !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexGest )* rowHeight;  
          this.viewportOperacionesGest.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      }else if(this.isBroker){
        if (this.indexBrok !== -1) {
          const rowHeight = 29.8;
          const scrollToOffset = (this.indexBrok )* rowHeight;  
          this.viewportOperacionesBrok.scrollToOffset(scrollToOffset);
          console.log(scrollToOffset);
        }
      } */
    }
  }

  private static leerSplitRatio(): number {
    try {
      const ratio = Number(localStorage.getItem('carteraBrokerSplit'));
      if (ratio >= 0.1 && ratio <= 0.9) return ratio;
    } catch { }
    return 0.5;
  }

  /** Arrastre del divisor entre posiciones y operaciones MT: abajo agranda posiciones, arriba operaciones. */
  iniciarResize(ev: MouseEvent, split: HTMLElement) {
    ev.preventDefault();
    this.finResize?.();
    const total = split.clientHeight - 6;
    if (total <= 0) return;
    const startY = ev.clientY;
    const ratioInicial = this.splitRatio;
    const mover = (e: MouseEvent) => {
      this.splitRatio = Math.min(0.9, Math.max(0.1, ratioInicial + (e.clientY - startY) / total));
      this.cdr.detectChanges();
      this.actualizarViewport();
    };
    const soltar = () => {
      document.removeEventListener('mousemove', mover);
      document.removeEventListener('mouseup', soltar);
      document.body.style.userSelect = '';
      this.finResize = null;
      try { localStorage.setItem('carteraBrokerSplit', String(this.splitRatio)); } catch { }
    };
    document.body.style.userSelect = 'none';
    document.addEventListener('mousemove', mover);
    document.addEventListener('mouseup', soltar);
    this.finResize = soltar;
  }

  /** Doble clic en el divisor: mitad y mitad. */
  resetSplit() {
    this.splitRatio = 0.5;
    try { localStorage.removeItem('carteraBrokerSplit'); } catch { }
    this.cdr.detectChanges();
    this.actualizarViewport();
  }

  ngOnDestroy(): void {
    this.finResize?.();
    this.posSubcription.unsubscribe();
    this.divPosSubcription.unsubscribe();
    this.gestPosSubcription.unsubscribe();
    this.subTemaService.unsubscribe();
  }

  actualizarViewport() {

    if (this.viewportGestion) {
      //console.log("actualizo el viewport viewportGestion");
      this.viewportGestion.checkViewportSize();
      this.viewportGestion.checkViewportSize();
    } if (this.viewportDiv) {
      this.viewportDiv.checkViewportSize();
      this.viewportDiv.checkViewportSize();
    } if (this.viewportCarteraGest) {
      //console.log("actualizo el viewport viewportDiv");
      this.viewportCarteraGest.checkViewportSize();
      this.viewportCarteraGest.checkViewportSize();
    }
    this.posicionesBroker?.actualizarViewport();
    this.listaOrdenes?.actualizarViewport();
  }

  selectRow(row: any) {
    this.filaSeleccionada = row;//fechaOperacion
    if (this.modelo) { this._controlService.updateFechaFiltro(this.filaSeleccionada.fechaOperacion); }
    else if (this.isPlanificador) { this._diversificadorsv.updateDivFechaFiltro(this.filaSeleccionada.fechaOperacion); }
    else if (this.isGestion) { this._gestorsv.updategestFechaFiltro(this.filaSeleccionada.fechaOperacion); }
  }

  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    console.log(this.filaSeleccionada);
  }

  verGrafica() {
    const jsonData = {
      idNectum: this.filaSeleccionada.idNectum,
      nombreComp: this.filaSeleccionada.nombreCompania,
      idModelo: this.filaSeleccionada.idcartera.toString(),
      isModelo: 'grafica'
    };
    this.queryParams = new URLSearchParams(jsonData).toString();
    window.open('/grafica-modelo/' + this.queryParams, '_blank');

  }

  verModelo() {
    if (this.filaSeleccionada.idmodelo !== 0) {
      const jsonData = {
        idNectum: this.filaSeleccionada.idNectum,
        nombreComp: this.filaSeleccionada.nombreCompania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    } else {
      this.showToast('Selecciona correctamente el activo para ver modelo.');
    }
  }

  // Método para mostrar el toast usando Toastr
  private showToast(message: string) {
    this.toastr.success(message, '', { timeOut: 3000, positionClass: 'toast-bottom-center' });
  }


  openDialog(broker: boolean): void {
    let fila = JSON.parse(JSON.stringify(this.filaSeleccionada));
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    let operaciones = JSON.parse(JSON.stringify(this.opeVentas));
    // Broker usa app-posiciones-broker; aquí solo llega Gestor
    const optimaWallet = this.GestOptimaWallet;
    const dialogRef = this.dialog.open(OpesalidaDialogComponent, {
      width: '420px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      panelClass: dialogClass,
      data: {
        compania: fila,
        opeventas: operaciones,
        optimaWallet: optimaWallet,
        stkcfd: this.stkcfd,
        isBroker: broker,
        isPosiciones: false,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.listaOrdenes?.recargar();
      }
    });
  }
  scrollToFirstDate(date: string) {
    if (this.modelo) {
      this.indexcat = this.posdata.data.findIndex(item => item.fechaOperacion === date);

    } else if (this.isPlanificador) {
      this.indexCatDiv = this.divPosdata.data.findIndex(item => item.fechaOperacion === date);
    }/*else if(this.isGestion){
      this.indexGest = this.GestDataOpe.data.findIndex(item => item.fechaOperacion === date);
    }else if(this.isBroker){
      this.indexBrok = this.BrokDataOpe.data.findIndex(item => item.fechaOperacion === date);
    } */

  }

  orderByField(dataSource: string, campo: string) {
    console.log("se hizo click en fecha de ", dataSource);

    if (dataSource == 'gestor' && campo === 'fechaOperacion') {
      let dataTemp = this.gestPosdata.data;
      dataTemp.sort((a, b) => {
        const dateA = new Date(a.fechaOperacion);
        const dateB = new Date(b.fechaOperacion);
        return dateB.getTime() - dateA.getTime();
      });
      this.gestPosdata.data = this.updateCounter([...dataTemp]);

    } else if (dataSource == 'gestor' && campo == 'nombreCompania') {
      let dataTemp = this.gestPosdata.data;
      dataTemp.sort((a, b) => {
        const nameA = a.nombreCompania.toLowerCase();
        const nameB = b.nombreCompania.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      this.gestPosdata.data = this.updateCounter([...dataTemp]);
    }
    if (dataSource == 'divPosdata' && campo === 'fechaOperacion') {
      let dataTemp = this.divPosdata.data;
      dataTemp.sort((a, b) => {
        const dateA = new Date(a.fechaOperacion);
        const dateB = new Date(b.fechaOperacion);
        return dateB.getTime() - dateA.getTime();
      });
      this.divPosdata.data = this.updateCounter([...dataTemp]);

    } else if (dataSource == 'divPosdata' && campo == 'nombreCompania') {
      let dataTemp = this.divPosdata.data;
      dataTemp.sort((a, b) => {
        const nameA = a.nombreCompania.toLowerCase();
        const nameB = b.nombreCompania.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      this.divPosdata.data = this.updateCounter([...dataTemp]);
    }
    if (dataSource == 'posdata' && campo === 'fechaOperacion') {
      let dataTemp = this.posdata.data;
      dataTemp.sort((a, b) => {
        const dateA = new Date(a.fechaOperacion);
        const dateB = new Date(b.fechaOperacion);
        return dateB.getTime() - dateA.getTime();
      });
      this.posdata.data = this.updateCounter([...dataTemp]);

    } else if (dataSource == 'posdata' && campo == 'nombreCompania') {
      let dataTemp = this.posdata.data;
      dataTemp.sort((a, b) => {
        const nameA = a.nombreCompania.toLowerCase();
        const nameB = b.nombreCompania.toLowerCase();
        if (nameA < nameB) return -1;
        if (nameA > nameB) return 1;
        return 0;
      });
      this.posdata.data = this.updateCounter([...dataTemp]);
    }
    this.cdr.detectChanges();
  }

  updateCounter(data: operationinterface[]): operationinterface[] {
    this.contadorFilas = 0; // Reinicia el contador del lote
    return data.map(item => {
      item.numoperaciones = ++this.contadorFilas; // Incrementa y asigna el contador del lote
      return item;
    });
  }
  formatHoraCotizacion(timestamp: number): string {
    // Sin valor (0): new Date(0) saldría como 01:00:00 en hora de Madrid.
    if (!timestamp) return '—';
    return this.datePipe.transform(new Date(timestamp * 1000), 'HH:mm:ss') || '';
  }
}
